var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('location'),_c('anonym'),_c('comments'),_c('div',{staticClass:"flix-mt-50"},[_c('h4',[_vm._v(_vm._s(_vm.$t("time.lastMinute.title")))]),_c('lastMinute')],1),(_vm.checkData())?_c('saveBtn',{staticClass:"saveBtn",attrs:{"callback":function() {
        _vm.setSave();
      }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }